import { apiFetch } from '@/lib/api-client';
import type { SubmitRatingResponse } from '@/features/story/api';

interface BookRatingResponse {
  id: string;
  bookOrderId: string;
  rating: number;
  comment: string | null;
  ratedAt: string;
}

/**
 * Thin adapter that posts a book rating and normalises the response
 * into the audio-side `SubmitRatingResponse` shape (`ratingStars`,
 * `ratingText`) so the shared `RatingWidget` can consume the result
 * without changes. Signature matches the `submit` prop of
 * `RatingWidget` — the first argument is the opaque entity id, which
 * in the book context is the BookOrder id.
 */
export async function submitBookRating(
  bookOrderId: string,
  payload: { rating: number; comment?: string },
): Promise<SubmitRatingResponse> {
  const raw = await apiFetch<BookRatingResponse>(
    `/api/book-orders/${encodeURIComponent(bookOrderId)}/rating`,
    { method: 'POST', body: payload },
  );
  return {
    id: raw.id,
    ratingStars: raw.rating,
    ratingText: raw.comment,
    ratedAt: raw.ratedAt,
  };
}
